import { configureStore } from '@reduxjs/toolkit';
import loginReducer from './features/loginSlice';
import mfaReducer from './features/mfaSlice';

export const store = configureStore({
  reducer: {
    login: loginReducer,
    mfa: mfaReducer,
  },
});

export default store;